import React from "react";
import { Accordion } from "react-bootstrap";
import { useParams } from "react-router-dom";
import "../../../../../../src/styles/sideCardAccordions.css";
import ThemedCardComponent from "../../../genericComponents/themedCardCompoennt";

export default function SolutionsAccordionProducts({ solutions }) {
  const { clientName } = useParams();

  return (
    <ThemedCardComponent
      title={
        <div className="sideCardContentTitle m-2">
         Relevant {clientName} Offerings
        </div>
      }
      description={
        <div className="sidecardacc-ideas-accordion">
          <Accordion flush>
            {solutions?.map((data, index) => (
              <Accordion.Item
                eventKey={index.toString()}
                key={index}
                className="sidecardacc-ideas-item"
              >
                <Accordion.Header>
                  <div className="accordion-header-content">
                    <div className="icon-wrapper">
                      <img
                        src="/img/icons/rocket_pink.png"
                        alt="Rocket icon"
                        className="accordion-icon"
                      />
                    </div>
                    <div className="title-wrapper">
                      {typeof data?.solution_name === "string"
                        ? data?.solution_name
                        : "Untitled Solution"}
                    </div>
                  </div>
                </Accordion.Header>

                <Accordion.Body className="sidecardacc-ideas-content">
                  <div className="content-wrapper">
                  {Object.entries(data || {})
                    ?.filter(([key, value]) => typeof value === "string" && !["solution_name","id", "name"].includes(key))
                    ?.map(([key, value]) => (
                      <p key={key} className="product-description">{value}</p>
                  ))}

                {data?.value_selling_questions ? (
                  <div className="product-benefits">
                    <h5>Value Selling Prompters</h5>
                    <ul>
                      {data.value_selling_questions.map((vsp, index) => (
                        <li key={index}>{vsp}</li>
                      ))}
                    </ul>
                  </div>
                ) : data?.value_selling_prompters ? (
                  <div className="product-benefits">
                    <h5>Value Selling Prompters</h5>
                    <ul>
                      {data.value_selling_prompters.map((vsp, index) => (
                        <li key={index}>{vsp}</li>
                      ))}
                    </ul>
                  </div>
                ) : null}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      }
    />
  );
}
